export interface RecoverPasswordResult {
	/**
	 * Siempre `true` cuando la petición se procesó, y no llega nada más: la respuesta
	 * es idéntica exista o no la cuenta. Nunca delata quién está en el sistema.
	 */
	success: boolean;
}

/**
 * El identificador de recuperación es el mismo que el del login: NIF o correo, y lo
 * decide la "@" — el usuario no elige entre dos campos.
 *
 * El backend busca el correo tanto en el corporativo como en el personal, así que quien
 * está de baja y ya no lee el suyo de empresa puede recuperarse igual.
 */
const forgetPassword = async (identifier: string): Promise<RecoverPasswordResult> => {
	const trimmedIdentifier = identifier.trim();
	const body = trimmedIdentifier.includes('@')
		? { email: trimmedIdentifier }
		: { nif: trimmedIdentifier };

	const response = await fetch(`${process.env.REACT_APP_BASE_API}/users/forget-password`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(body)
	});

	// El `success` de fuera solo dice que el HTTP fue bien; el resultado de negocio vive
	// en `data`. En un 400 de validación `data` es la lista de errores, no un objeto.
	const parsed = await response.json();
	const result = parsed?.data;

	return typeof result === 'object' && result !== null ? result : { success: false };
};

export default forgetPassword;
